<template>
  <div class="home">
    <button
      class="button field is-info is-light"
      @click="isCardModalActive = true"
    >
      <b-icon icon="plus"></b-icon>
      <span>Novo pedágio</span>
    </button>
    <b-table
      :data="allTolls"
      ref="table"
      paginated
      per-page="10"
      :striped="true"
      :debounce-search="1000"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column field="id" label="ID" width="40" numeric v-slot="props">{{
        props.row.id
      }}</b-table-column>

      <b-table-column
        field="name"
        label="Nome"
        :searchable="true"
        sortable
        v-slot="props"
      >
        {{ props.row.name.toUpperCase() }}
      </b-table-column>

      <b-table-column
        field="value"
        label="Valor"
        :searchable="true"
        sortable
        v-slot="props"
        >R$ {{ parseFloat(props.row.value).toFixed(2) }}</b-table-column
      >

      <b-table-column label="Opções" v-slot="props">
        <button
          class="button is-small is-light"
          @click.prevent="
            onEdit(props.row)
            isCardModalActive = true
          "
        >
          <b-icon icon="pen" size="is-small"></b-icon>
        </button>
        <button
          class="button is-small is-danger"
          @click.prevent="onDelete(props.row.id)"
        >
          <b-icon icon="delete" size="is-small"></b-icon>
        </button>
      </b-table-column>
    </b-table>
    <b-modal v-model="isCardModalActive" :width="640" scroll="keep">
      <div class="card">
        <div class="card-content">
          <div class="content">
            <b-field label="Nome">
              <b-input v-model="model.name"> </b-input>
            </b-field>
            <b-field label="Valor">
              <b-input v-money="moneyFormat" v-model="model.value"> </b-input>
            </b-field>
            <b-button @click="save" type="button field is-info" class="mt-10"
              >Salvar</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import service from '../features/tolls/store/service'
import Toll from '../models/toll'

import Cleave from 'cleave.js'

/**
 * We add a new instance of Cleave when the element
 * is bound and destroy it when it's unbound.
 */
const cleave = {
  name: 'cleave',
  bind(el, binding) {
    const input = el.querySelector('input')
    input._vCleave = new Cleave(input, binding.value)
  },
  unbind(el) {
    const input = el.querySelector('input')
    input._vCleave.destroy()
  },
}

export default {
  name: 'Tolls',
  directives: { cleave },
  data() {
    return {
      model: Toll.model,
      showDetailIcon: false,
      isCardModalActive: false,
      moneyFormat: {
        prefix: 'R$ ',
        sstatefix: '',
        precision: 2,
        masked: false,
      },
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapState('tolls', ['allTolls']),
  },
  methods: {
    ...mapActions('tolls', ['getAllTolls']),
    async init() {
      await this.getAllTolls()
    },
    async save() {
      const toll = { ...this.model }

      toll.value = toll.value.replace('R$', '')

      try {
        const save = toll.id
          ? await service.updateTolls(toll)
          : await service.saveTolls(toll)

        await this.$success('Pedágio')
        await location.reload(true)
      } catch (error) {
        this.$error(
          error.response.data.message || error.response.data[0].message
        )
      }
    },
    onEdit(item) {
      this.model = { ...item }

      this.model.value = parseFloat(item.value).toFixed(2)

      console.log(item)
    },
    async onDelete(id) {
      try {
        const result = await this.$ask('Você deseja remover o pedágio?')

        if (result.isConfirmed) {
          await service.deleteTolls(id)

          await this.$delete('Pedágio')
          location.reload(true)
        }
      } catch (error) {
        this.$error(error.response.data.message)
      }
    },
  },
}
</script>

<style scoped></style>
